import type { ValidationResult, ValidationRule } from '../types';

export const isMaxLength = (errorMessage: string, maxLength: number): ValidationRule => (
  inputToValidate: string
): ValidationResult => {
  const isValid = inputToValidate ? inputToValidate.length <= maxLength : true;
  return { error: !isValid, errorMessage };
};
